/* eslint-disable no-unused-vars */
import { useCallback } from "react";
import { IReferenceCode } from "@/lib/interfaces and Enums/ENUMReferenceList";
import {
  findReferenceCode,
  searchReferenceCodes,
} from "@/store/referenceListsStoreACTIONS";
import { returnReferenceDataOptions } from "../helper/ticketSharedHelper";
import { returnReferenceCodeLabel } from "../helper/referenceListOptions";
import ReferenceDataSelect from "./ReferenceDataSelect";

// LQC-2933 - typeahead over GET /ReferenceData/Calendars (186 codes, too many for a
// dropdown). Until the list loads it shows the currency-derived code, which is valid.

interface ICalendarSelect {
  value: string;
  onChange: (calendar: string) => void;
  calendars: IReferenceCode[];
  isReady: boolean;
  testId: string;
}

const CalendarSelect = ({
  value,
  onChange,
  calendars,
  isReady,
  testId,
}: ICalendarSelect) => {
  const searchOptions = useCallback(
    (term: string, limit: number) =>
      returnReferenceDataOptions(searchReferenceCodes(calendars, term, limit), (item) => ({
        label: returnReferenceCodeLabel(item),
        value: item.code,
      })),
    [calendars],
  );

  if (!isReady) {
    return (
      <div data-testid={testId} id={testId} className="px-1 text-xs dark:text-gray-200">
        {value || "-"}
      </div>
    );
  }

  const match = findReferenceCode(calendars, value);
  return (
    <ReferenceDataSelect
      testId={testId}
      placeholder="Search calendar ..."
      selected={
        value
          ? { label: match ? returnReferenceCodeLabel(match) : value, value }
          : null
      }
      searchOptions={searchOptions}
      onSelect={(option) => onChange(option?.value ?? "")}
    />
  );
};

export default CalendarSelect;
